export default __webpack_public_path__ + "static/media/iswanto-arif-u0lAovoUsaU-unsplash.3aa6fd2a.jpg";